export default __webpack_public_path__ + "assets/images/confirm-rm-selection.svg";